import { render, staticRenderFns } from "./CreateAccountConsents.vue?vue&type=template&id=47bd9ca0&scoped=true&"
import script from "./CreateAccountConsents.vue?vue&type=script&lang=js&"
export * from "./CreateAccountConsents.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccountConsents.vue?vue&type=style&index=0&id=47bd9ca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bd9ca0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/projects/tus-cc-auth/tus-cc-auth/frontend/tusauth/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VLayout,VSnackbar})
